"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CONTAINS_PARAMETERS = exports.diagnosticCodeUndefinedStep = void 0;
exports.diagnosticCodeUndefinedStep = 'cucumber.undefined-step';
exports.CONTAINS_PARAMETERS = /<.*?>/;
//# sourceMappingURL=constants.js.map